<script lang="ts">
	import { cn } from '$lib/utils/class-merge';
	import { startOfDay, isSunday, isToday, isAfter, subDays, format, isSameDay } from 'date-fns';

	type Props = {
		day: Date;
		value?: Date | undefined;
		minDate?: Date;
		selectDate: (date: Date) => void;
	};

	let { day, value, minDate, selectDate }: Props = $props();

	const isAllowed = (d: Date) => {
		d = startOfDay(d);
		if (minDate) {
			return isAfter(d, startOfDay(subDays(minDate, 1)));
		}
		return true;
	};

	const isSelected = (d: Date) => {
		if (value) {
			return isSameDay(d, value);
		}
		return false;
	};

	const setDate = (d: Date) => {
		if (isAllowed(d)) {
			selectDate(d);
		}
	};
</script>

<button
	type="button"
	class={cn(
		'relative border border-transparent rounded-xl hover:bg-one cursor-pointer px-2.5 py-2 text-center font-semibold',
		{
			'text-primary after:content-["today"] after:text-[9px] after:top-0 after:absolute after:left-0 after:right-0 after:mx-auto':
				isToday(day),
			'text-red-600 dark:text-red-300': isSunday(day),
			'text-slate-300 dark:text-slate-600 cursor-not-allowed': !isAllowed(day),
			'bg-primary text-one text-lg': isSelected(day)
		}
	)}
	onclick={(e) => {
		e.stopPropagation();
		setDate(day);
	}}
>
	{format(day, 'd')}
</button>
